<template class="justify-center">
  <v-col
    :cols="12"
    :xm="12"
    :sm="12"
    :md="12"
    :lg="12"
    :xl="12"
  >
    <v-card
      class="mx-auto pa-4"
      tile
    >
      <div id="camera" />
      <v-list disabled>
        <v-subheader>
          Você está prestes a iniciar a sua aula
        </v-subheader>
        <v-list-item-group
          v-model="item"
          color="primary"
        >
          <v-list-item
            v-for="(item, i) in items"
            :key="i"
            class="list"
          >
            <v-list-item-icon>
              <v-icon
                v-text="item.icon"
              />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                v-text="item.text"
              />
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <v-btn
        color="primary"
        :loading="loading"
        @click="chamarCamera"
      >
        Iniciar Aula
      </v-btn>
    </v-card>
  </v-col>
</template>


<script>


  export default {
    data: () => ({
      loading: false,
      disabled: false,
      items: [
        { text: 'Certifique-se de que sua câmera tem ao menos 720 pixels de resolução;', icon: 'warning'},
        { text: 'Confira se o ambiente está bem iluminado para a coleta das biometriais faciais;', icon: 'warning' },
        { text: 'Não utilize bonés, chapéus ou algum item que dificulte o reconhecimento facial;', icon: 'warning' },
        { text: 'Fique em frente à câmera para a coleta digital.', icon: 'offline_pin' },
      ],
    }),
    created() {
      //this.chamarCamera();
    },
    methods: {
      chamarCamera() {
        this.loading = true;
        let element = document.getElementsByClassName('list');
        for (let i = 1; i< element.length; i++) {
          element[i].children[0].children[0].classList.add('success--text');
          element[i].children[1].children[0].classList.add('success--text');
        }

        const constraints = this.configuracaoAudiovideo()

        this.verificaCameras(constraints);
      },
      async verificaCameras(constraints) {
        try {
            const response = await navigator.mediaDevices.getUserMedia(constraints);
            setTimeout(function () {
              document.dispatchEvent(new CustomEvent('carregaInicio'))
            }, 100);
            response.getVideoTracks().forEach((track) => {
              const {height, width} = track.getSettings();


              if (height < 720 || width < 960) {
                let element = document.getElementsByClassName('list')[0];
                element.children[0].children[0].classList.add('error--text');
                element.children[1].children[0].classList.add('error--text');
                alert("Não foi possível se comunicar com a câmera, por favor, verifique foi concedido o acesso à aplicação.");
                this.loading = false;
              } else {
                let element = document.getElementsByClassName('list')[0];
                element.children[0].children[0].classList.add('success--text');
                element.children[1].children[0].classList.add('success--text');
                this.loading = false;
              }

          })
        } catch(error) {
          alert("Não foi possível se comunicar com a câmera, por favor, verifique foi concedido o acesso à aplicação.");
        }
      },
      configuracaoAudiovideo() {
        const config = {
                'video': {
                  width: 960,
                  height:720,
                  },
                'audio': true
              };
        return config;
      },
    }
  }

</script>
<style scoped>
  .error {
    color: red;
  }
</style>
